
var siteNav = (function(){

    toggle = $( ".js-menu-toggle" );
    menu = $( ".js-menu" );
    header = $( ".header" );
    searchToggle = $(".js-search-toggle");


    function showNav() {
        menu.addClass('nav-open');
        $("body").addClass('nav-open');
        window.setTimeout(function(){$('body').addClass('no-scroll');}, 200); // Firefox hack. Hides scrollbar as soon as menu animation is done
        $('.nav--main a').attr('tabindex', ''); // links inside navigation should be TAB selectable
    }

    function hideNav() {
        menu.removeClass('nav-open');
        $("body").removeClass('nav-open');
        window.setTimeout(function(){$('body').removeClass('no-scroll');}, 10); // allow animations to start before removing class (Firefox)
       $('.nav--main a').attr('tabindex', '-1'); // links inside hidden navigation should not be TAB selectable
    }

    function showHideNav() {
      if ($(".js-menu").hasClass('nav-open')) {
        hideNav();
      } else {
        showNav();
      }
    }

    // shows/hides navigation’s popover if class "expanded"
    toggle.on('click touchstart', function(event) {
      showHideNav();
      event.preventDefault();
    });


    $('body').keydown(function(e) {
      // menu accessible via TAB as well
      if (toggle.is(":focus")) {
        // if ENTER/SPACE show/hide menu
        if (e.keyCode === 13 || e.keyCode === 32) {
          showHideNav();
          e.preventDefault();
        }
      }
    });

    $(".nav--main > .menu-item-has-children > a:not(:only-child)").click(function (event) {
      event.preventDefault();
      var width = $(window).width();
      if (width < 979) {
        if ($(this).parent().attr("aria-expanded") == "true" && $(this).parent().hasClass("sub-menu--open")) {
          $(this).parent().attr("aria-expanded", "false");
          $(this).parent().removeClass("sub-menu--open");
          $(this).next().fadeOut(200);
        } else {
          $(this).parent().attr("aria-expanded", "true");
          $(this).parent().addClass("sub-menu--open");
          $(this).next().fadeIn(200);
        }
      }
      if (width > 980) {
        if ($(this).parent().attr("aria-expanded") == "true" && $(this).parent().hasClass("sub-menu--open")) {
          $(this).parent().attr("aria-expanded", "false");
          $(this).parent().removeClass("sub-menu--open");
          $(this).next().fadeOut(200);
        } else {
          $(this).parent().attr("aria-expanded", "true");
          $(this).parent().addClass("sub-menu--open");
          $(this).next().fadeIn(200);
          $(".sub-menu").not($(this).next()).parent().attr("aria-expanded", "false");
          $(".sub-menu").not($(this).next()).parent().removeClass("sub-menu--open");
          $(".sub-menu").not($(this).next()).fadeOut(200);
        }
        event.stopPropagation();
      }
    });

    $(document).keydown(function(event) { 
      if (event.keyCode == 27) { 
        if ($(".nav--main > .menu-item-has-children") && $(window).width() > 980) {
          $(".nav--main > .menu-item-has-children").attr("aria-expanded", "false");
          $(".nav--main > .menu-item-has-children").removeClass("sub-menu--open");
          $(".nav--main > .menu-item-has-children").children(".sub-menu").fadeOut(200);
        }
      }
    });

    $("html").click(function() {
      if ($(window).width() > 980) {
        $(".sub-menu").parent().attr("aria-expanded", "false");
        $(".sub-menu").parent().removeClass("sub-menu--open");
        $(".sub-menu").fadeOut(200);
      }
    });

    $(".menu-item-has-children a").click(function(event){
      event.stopPropagation();
    });

    searchToggle.on('click touchstart', function(event) {
      $(".search-box").toggleClass("visible");
      event.preventDefault();
    });
})();
